const STORAGE_KEY = 'ollaa_owner_pin_verified_until';

const readVerifiedUntil = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const ts = Date.parse(raw);
    return Number.isFinite(ts) ? ts : null;
  } catch {
    return null;
  }
};

export default {
  namespaced: true,
  state: {
    verifiedUntil: readVerifiedUntil(),
  },
  getters: {
    isOwnerPinVerified: (state) => {
      const until = state.verifiedUntil || readVerifiedUntil();
      return Boolean(until && until > Date.now());
    },
  },
  mutations: {
    SET_VERIFIED_UNTIL(state, iso) {
      state.verifiedUntil = iso ? Date.parse(iso) : null;
      try {
        if (iso) localStorage.setItem(STORAGE_KEY, iso);
        else localStorage.removeItem(STORAGE_KEY);
      } catch {
        // ignore
      }
    },
    CLEAR(state) {
      state.verifiedUntil = null;
      try {
        localStorage.removeItem(STORAGE_KEY);
      } catch {
        // ignore
      }
    },
  },
};
